//Types for Auth
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const USER_AUTHENTICATED = "USER_AUTHENTICATED";
export const USER_NOT_AUTHENTICATED = "USER_NOT_AUTHENTICATED";
export const CLEAR_STORE_DATA = "CLEAR_STORE_DATA";
export const SET_AUTH_DATA_LOADING = "SET_AUTH_DATA_LOADING";

//Types for Super Admin
export const GET_COMPANY_LIST_FOR_ADMIN = "GET_COMPANY_LIST_FOR_ADMIN";
export const COMPANY_LIST_FOR_ADMIN_LOADING = "COMPANY_LIST_FOR_ADMIN_LOADING";
export const COMPANY_LIST_FOR_ADMIN_LOADED = "COMPANY_LIST_FOR_ADMIN_LOADED";
export const SET_SELECTED_COMPANY = "SET_SELECTED_COMPANY";
export const SET_SELECTED_COMPANY_ADMIN = "SET_SELECTED_COMPANY_ADMIN";
export const SET_SELECTED_COMPANY_ID = "SET_SELECTED_COMPANY_ID";

//Types for Company
export const GET_COMPANY_DETAILS = "GET_COMPANY_DETAILS";
export const ADD_COMPANY_DETAILS = "ADD_COMPANY_DETAILS";
export const DATA_LOADING = "DATA_LOADING";

export const UPDATE_ACCOUNT_USER_AUTHORIZATION =
	"UPDATE_ACCOUNT_USER_AUTHORIZATION";
export const ADD_NEW_ACCOUNT_USER = "ADD_NEW_ACCOUNT_USER";
export const REMOVE_ACCOUNT_USER = "REMOVE_NEW_ACCOUNT_USER";

export const UPDATE_NOTIFICATION_READ_STATUS =
	"UPDATE_NOTIFICATION_READ_STATUS";

//Types for Company User
export const GET_COMPANY_USER_DETAILS = "GET_COMPANY_USER_DETAILS";
export const UPDATE_COMPANY_USER_DETAILS = "UPDATE_COMPANY_USER_DETAILS";
export const COMPANY_USER_DATA_LOADING = "COMPANY_USER_DATA_LOADING";
export const SET_COMPANY_PROFILE_COMPLETE_STATUS =
	"SET_COMPANY_PROFILE_COMPLETE_STATUS";
export const SET_OWN_PROFILE_COMPLETE_STATUS =
	"SET_OWN_PROFILE_COMPLETE_STATUS";

//Types for Students
export const GET_ALL_STUDENTS = "GET_ALL_STUDENTS";
export const STUDENT_DATA_LOADING = "STUDENT_DATA_LOADING";
export const STUDENT_DATA_LOADED = "STUDENT_DATA_LOADED";
export const SORT_STUDENT_DATA = "SORT_STUDENT_DATA";
export const SEARCH_STUDENT_DATA = "SEARCH_STUDENT_DATA";
export const SET_STUDENT_SEARCH_SUGGESTION = "SET_STUDENT_SEARCH_SUGGESTION";
export const STUDENT_TO_SHOW_DATA_LOADED = "STUDENT_TO_SHOW_DATA_LOADED";
export const STUDENT_TO_SHOW_DATA_UNLOADED = "STUDENT_TO_SHOW_DATA_UNLOADED";

export const GET_ALL_PAST_STUDENTS = "GET_ALL_PAST_STUDENTS";
export const PAST_STUDENT_DATA_LOADING = "PAST_STUDENT_DATA_LOADING";
export const PAST_STUDENT_DATA_LOADED = "PAST_STUDENT_DATA_LOADED";

export const SET_STUDENT_ACCEPT_DATA_IN_MAIN_LIST =
	"SET_STUDENT_ACCEPT_DATA_IN_MAIN_LIST";

//Types for Survey
export const SURVEY_DATA_LOADING = "SURVEY_DATA_LOADING";
export const GET_SURVEY_QUESTION = "GET_SURVEY_QUESTION";
export const ADD_SURVEY_QUESTION = "ADD_SURVEY_QUESTION";
export const PUBLISH_SURVEY_QUESTION = "PUBLISH_SURVEY_QUESTION";
export const UNPUBLISH_SURVEY_QUESTION = "UNPUBLISH_SURVEY_QUESTION";

//Types for ChatRoom
export const GET_AVAILABLE_CHAT_LISTS = "GET_AVAILABLE_CHAT_LISTS";
export const START_CHAT_LIST_LOADING = "START_CHAT_LIST_LOADING";
export const STOP_CHAT_LIST_LOADING = "STOP_CHAT_LIST_LOADING";
export const START_MESSAGE_LOADING = "START_MESSAGE_LOADING";
export const STOP_MESSAGE_LOADING = "STOP_MESSAGE_LOADING";
export const GET_COMPANY_METADATA = "GET_COMPANY_METADATA";
export const GET_STUDENT_METADATA = "GET_STUDENT_METADATA";
export const SET_SELECTED_CHAT = "SET_SELECTED_CHAT";
export const CLEAR_CHAT_ROOM_DATA = "CLEAR_CHAT_ROOM_DATA";
export const SET_CHAT_FILEUPLOAD_LOADING = "SET_CHAT_FILEUPLOAD_LOADING";
export const SET_CHAT_FILEUPLOAD_PROGRESS = "SET_CHAT_FILEUPLOAD_PROGRESS";

// Types for ChatRoomGalkLab
export const _GET_AVAILABLE_CHAT_LISTS = "_GET_AVAILABLE_CHAT_LISTS";
export const _START_CHAT_LIST_LOADING = "_START_CHAT_LIST_LOADING";
export const _STOP_CHAT_LIST_LOADING = "_STOP_CHAT_LIST_LOADING";
export const _START_MESSAGE_LOADING = "_START_MESSAGE_LOADING";
export const _STOP_MESSAGE_LOADING = "_STOP_MESSAGE_LOADING";
export const _GET_COMPANY_METADATA = "_GET_COMPANY_METADATA";
export const _GET_STUDENT_METADATA = "_GET_STUDENT_METADATA";
export const _SET_SELECTED_CHAT = "_SET_SELECTED_CHAT";
export const _CLEAR_CHAT_ROOM_DATA = "_CLEAR_CHAT_ROOM_DATA";
export const _SET_CHAT_FILEUPLOAD_LOADING = "_SET_CHAT_FILEUPLOAD_LOADING";
export const _SET_CHAT_FILEUPLOAD_PROGRESS = "_SET_CHAT_FILEUPLOAD_PROGRESS";

//Types for Language set
export const SET_LANGUAGE = "SET_LANGUAGE";

/********************************************************************************************/

//Types for Dashboard
export const GET_DASHBOARD_BASIC = "GET_DASHBOARD_BASIC";
export const SET_DASHBOARD_BASIC_LOADING = "SET_DASHBOARD_BASIC_LOADING";

export const GET_DASHBOARD_STUDENT_STAT = "GET_DASHBOARD_STUDENT_STAT";
export const SET_DASHBOARD_STUDENT_STAT_LOADING =
	"SET_DASHBOARD_STUDENT_STAT_LOADING";

export const GET_DASHBOARD_COMPANY_STAT = "GET_DASHBOARD_COMPANY_STAT";
export const SET_DASHBOARD_COMPANY_STAT_LOADING =
	"SET_DASHBOARD_COMPANY_STAT_LOADING";

export const GET_GALK_NEWS = "GET_GALK_NEWS";
export const SET_GALK_NEWS_LOADING = "SET_GALK_NEWS_LOADING";

export const GET_VISITOR_LIST = "GET_VISITOR_LIST";
export const SET_VISITOR_LIST_LOADING = "SET_VISITOR_LIST_LOADING";

export const GET_DASHBOARD_ANALYTIC = "GET_DASHBOARD_ANALYTIC";
export const SET_DASHBOARD_ANALYTIC_LOADING = "SET_DASHBOARD_ANALYTIC_LOADING";

export const GET_DEPARTMENT_ANALYTIC = "GET_DEPARTMENT_ANALYTIC";
export const SET_DEPARTMENT_ANALYTIC_LOADING =
	"SET_DEPARTMENT_ANALYTIC_LOADING";
export const SET_ORGANISATION_DATA_COLLECTION_DATA =
	"SET_ORGANISATION_DATA_COLLECTION_DATA";
export const SET_DASHBOARD_DATA = "SET_DASHBOARD_DATA";
export const GET_DASHBOARD_CURRENT_YEAR_STAT =
	"GET_DASHBOARD_CURRENT_YEAR_STAT";
export const GET_DASHBOARD_INTERNSHIP_COUNT = "GET_DASHBOARD_INTERNSHIP_COUNT";
export const GET_DASHBOARD_LIKE_STAT = "GET_DASHBOARD_LIKE_STAT";
export const SET_DASHBOARD_LIKE_STAT_LOADING =
	"SET_DASHBOARD_LIKE_STAT_LOADING";
export const SET_DASHBOARD_CALENDAR_EVENTS = "SET_DASHBOARD_CALENDAR_EVENTS";
export const SET_DASHBOARD_CALENDAR_EVENTS_LOADING =
	"SET_DASHBOARD_CALENDAR_EVENTS_LOADING";
export const SET_DASHBOARD_CURRENT_YEAR_STAT_LOADING =
	"SET_DASHBOARD_CURRENT_YEAR_STAT_LOADING";
export const SET_DASHBOARD_INTERNSHIP_COUNT_LOADING =
	"SET_DASHBOARD_INTERNSHIP_COUNT_LOADING";
//Types for Third year students

export const GET_TAGGED_THIRD_YEAR_STUDENTS = "GET_TAGGED_THIRD_YEAR_STUDENTS";
export const SET_INTERNSHIP_INTERVIEW_DETAILS =
	"SET_INTERNSHIP_INTERVIEW_DETAILS";
export const SET_TAGGED_THIRD_YEAR_STUDENTS_LOADING =
	"SET_TAGGED_THIRD_YEAR_STUDENTS_LOADING";
export const GET_STUDENT_TO_SHOW_DETAILS = "GET_STUDENT_TO_SHOW_DETAILS";
export const RESET_STUDENT_TO_SHOW_DETAILS = "RESET_STUDENT_TO_SHOW_DETAILS";
export const SET_STUDENT_TO_SHOW_DETAILS_LOADING =
	"SET_STUDENT_TO_SHOW_DETAILS_LOADING";
export const FILTER_THIRD_YEAR_STUDENTS = "FILTER_THIRD_YEAR_STUDENTS";
export const SET_ACTION_IN_PRROGRESS_FOR_THIRD_YEAR =
	"SET_ACTION_IN_PRROGRESS_FOR_THIRD_YEAR";
export const REQUEST_INTERVIEW_FOR_THIRD_YEAR =
	"REQUEST_INTERVIEW_FOR_THIRD_YEAR";

export const GALKLab_GET_STUDENT_TO_SHOW_DETAILS =
	"GALKLab_GET_STUDENT_TO_SHOW_DETAILS";
export const GALKLab_RESET_STUDENT_TO_SHOW_DETAILS =
	"GALKLab_RESET_STUDENT_TO_SHOW_DETAILS";
export const GALKLab_SET_STUDENT_TO_SHOW_DETAILS_LOADING =
	"GALKLab_SET_STUDENT_TO_SHOW_DETAILS_LOADING";
export const GALKLab_FILTER_THIRD_YEAR_STUDENTS =
	"GALKLab_FILTER_THIRD_YEAR_STUDENTS";
export const GALKLab_SET_ACTION_IN_PRROGRESS_FOR_THIRD_YEAR =
	"GALKLab_SET_ACTION_IN_PRROGRESS_FOR_THIRD_YEAR";
export const GALKLab_REQUEST_INTERVIEW_FOR_THIRD_YEAR =
	"GALKLab_REQUEST_INTERVIEW_FOR_THIRD_YEAR";

//Types for Fourth year students

export const GET_TAGGED_FOURTH_YEAR_STUDENTS =
	"GET_TAGGED_FOURTH_YEAR_STUDENTS";
export const SET_TAGGED_FOURTH_YEAR_STUDENTS_LOADING =
	"SET_TAGGED_FOURTH_YEAR_STUDENTS_LOADING";
export const GET_FOURTH_YEAR_STUDENT_TO_SHOW_DETAILS =
	"GET_FOURTH_YEAR_STUDENT_TO_SHOW_DETAILS";
export const RESET_FOURTH_YEAR_STUDENT_TO_SHOW_DETAILS =
	"RESET_FOURTH_YEAR_STUDENT_TO_SHOW_DETAILS";
export const SET_FOURTH_YEAR_STUDENT_TO_SHOW_DETAILS_LOADING =
	"SET_FOURTH_YEAR_STUDENT_TO_SHOW_DETAILS_LOADING";
export const FILTER_FOURTH_YEAR_STUDENTS = "FILTER_FOURTH_YEAR_STUDENTS";
export const SET_ACTION_IN_PRROGRESS_FOR_FOURTH_YEAR =
	"SET_ACTION_IN_PRROGRESS_FOR_FOURTH_YEAR";
export const REQUEST_INTERVIEW_FOR_FOURTH_YEAR =
	"REQUEST_INTERVIEW_FOR_FOURTH_YEAR";

//Types for Interview panel

export const GET_STUDENTS_IN_INTERVIEW_PANEL =
	"GET_STUDENTS_IN_INTERVIEW_PANEL";
export const SET_STUDENTS_IN_INTERVIEW_PANEL_LOADING =
	"SET_STUDENTS_IN_INTERVIEW_PANEL_LOADING";
export const GET_STUDENT_TO_SHOW_DETAILS_IN_INTERVIEW_PANEL =
	"GET_STUDENT_TO_SHOW_DETAILS_IN_INTERVIEW_PANEL";
export const RESET_STUDENT_TO_SHOW_DETAILS_IN_INTERVIEW_PANEL =
	"RESET_STUDENT_TO_SHOW_DETAILS_IN_INTERVIEW_PANEL";
export const SET_STUDENT_TO_SHOW_DETAILS_IN_INTERVIEW_PANEL_LOADING =
	"SET_STUDENT_TO_SHOW_DETAILS_IN_INTERVIEW_PANEL_LOADING";
export const SET_ACTION_IN_PRROGRESS_FOR_STUDENT_IN_INTERVIEW_PANEL =
	"SET_ACTION_IN_PRROGRESS_FOR_STUDENT_IN_INTERVIEW_PANEL";
export const SELECT_STUDENT_IN_INTERVIEW_PANEL =
	"SELECT_STUDENT_IN_INTERVIEW_PANEL";
export const RESET_STUDENT_LIST_IN_INTERVIEW_PANEL =
	"RESET_STUDENT_LIST_IN_INTERVIEW_PANEL";

//Types for Internship jobs
export const GET_INTERNSHIP_JOBS = "GET_INTERNSHIP_JOBS";
export const SET_INTERNSHIP_JOBS_LOADING = "SET_INTERNSHIP_JOBS_LOADING";
export const GET_INTERNSHIP_JOB_TO_SHOW_DETAILS =
	"GET_INTERNSHIP_JOB_TO_SHOW_DETAILS";
export const RESET_INTERNSHIP_JOB_TO_SHOW_DETAILS =
	"RESET_INTERNSHIP_JOB_TO_SHOW_DETAILS";
export const SET_INTERNSHIP_JOBS_TO_SHOW_DETAILS_LOADING =
	"SET_INTERNSHIP_JOBS_TO_SHOW_DETAILS_LOADING";
export const SET_ACTION_IN_PRROGRESS_FOR_INTERNSHIP_JOB =
	"SET_ACTION_IN_PRROGRESS_FOR_INTERNSHIP_JOB";
export const DELETE_INTERNSHIP_JOBS = "DELETE_INTERNSHIP_JOBS";
export const RESET_INTERNSHIP_JOBS_LIST = "RESET_INTERNSHIP_JOBS_LIST";
export const ADD_INTERNSHIP_JOB = "ADD_INTERNSHIP_JOB";
export const UPDATE_INTERNSHIP_JOB = "UPDATE_INTERNSHIP_JOB";
export const UPDATE_INTERNSHIP_TAG_ASSIGNED = "UPDATE_INTERNSHIP_TAG_ASSIGNED";
export const UPDATE_INTERNSHIP_TAG_UNASSIGNED =
	"UPDATE_INTERNSHIP_TAG_UNASSIGNED";
export const UPDATE_INTERNSHIP_JOB_ASSIGN_PORCESSING =
	"UPDATE_INTERNSHIP_JOB_ASSIGN_PORCESSING";

// Types for new company profile
export const SET_ACTION_IN_PRROGRESS_FOR_COMPANY_PROFILE =
	"SET_ACTION_IN_PRROGRESS_FOR_COMPANY_PROFILE";
export const SET_COMPANY_PROFILE_LOGO = "SET_COMPANY_PROFILE_LOGO";
export const SET_COMPANY_USER_PROFILE_PICTURE =
	"SET_COMPANY_USER_PROFILE_PICTURE";
export const GET_COMPANY_USER_PROFILE_PICTURE =
	"GET_COMPANY_USER_PROFILE_PICTURE";
export const SET_COMPANY_PROFILE_COVER_PHOTO =
	"SET_COMPANY_PROFILE_COVER_PHOTO";
export const UPDATE_COMPANY_BASIC_INFORMATION =
	"UPDATE_COMPANY_BASIC_INFORMATION";
export const UPDATE_COMPANY_OPERATIONAL_INFORMATION =
	"UPDATE_COMPANY_OPERATIONAL_INFORMATION";
export const ADD_COMPANY_DOCUEMNT = "ADD_COMPANY_DOCUEMNT";
export const REMOVE_COMPANY_DOCUEMNT = "REMOVE_COMPANY_DOCUEMNT";

//Types for application module
export const APP_MODULE_LOADING = "APP_MODULE_LOADING";
export const SET_APPLIACTION_MODULE = "SET_APPLIACTION_MODULE";

//Types for GALK Lab
//Students
export const GALKLAB_SET_STUDENT_LIST_LOADING =
	"GALKLAB_SET_STUDENT_LIST_LOADING";
export const GALKLAB_GET_STUDENT_LIST = "GALKLAB_GET_STUDENT_LIST";
export const GALKLAB_GET_TAGGED_STUDENT_LIST =
	"GALKLAB_GET_TAGGED_STUDENT_LIST";
export const GALKLAB_SET_STUDENT_TO_SHOW_DETAILS_LOADING =
	"GALKLAB_SET_STUDENT_TO_SHOW_DETAILS_LOADING";
export const GALKLAB_GET_STUDENT_TO_SHOW_DETAILS =
	"GALKLAB_GET_STUDENT_TO_SHOW_DETAILS";
export const GALKLAB_RESET_STUDENT_TO_SHOW_DETAILS =
	"GALKLAB_RESET_STUDENT_TO_SHOW_DETAILS";
export const UPDATE_GALK_LAB_JOB_ASSIGNED_ENGINEER =
	"UPDATE_GALK_LAB_JOB_ASSIGNED_ENGINEER";

// Types for notification
export const NOTIFICATION_LOADING = "NOTIFICATION_LOADING";
export const NOTIFICATION_LOADED = "NOTIFICATION_LOADED";
export const NOTIFICATION_FAILED = "NOTIFICATION_FAILED";

//Types for Galk Lab jobs
export const GET_GALK_LAB_JOBS = "GET_GALK_LAB_JOBS";
export const SET_GALK_LAB_JOBS_LOADING = "SET_GALK_LAB_JOBS_LOADING";
export const GET_GALK_LAB_JOB_TO_SHOW_DETAILS =
	"GET_GALK_LAB_JOB_TO_SHOW_DETAILS";
export const RESET_GALK_LAB_JOB_TO_SHOW_DETAILS =
	"RESET_GALK_LAB_JOB_TO_SHOW_DETAILS";
export const SET_GALK_LAB_JOBS_TO_SHOW_DETAILS_LOADING =
	"SET_GALK_LAB_JOBS_TO_SHOW_DETAILS_LOADING";
export const SET_ACTION_IN_PROGRESS_FOR_GALK_LAB_JOB =
	"SET_ACTION_IN_PROGRESS_FOR_GALK_LAB_JOB";
export const DELETE_GALK_LAB_JOBS = "DELETE_GALK_LAB_JOBS";
export const RESET_GALK_LAB_JOBS_LIST = "RESET_GALK_LAB_JOBS_LIST";
export const ADD_GALK_LAB_JOB = "ADD_GALK_LAB_JOB";
export const UPDATE_GALK_LAB_JOB = "UPDATE_GALK_LAB_JOB";
export const UPDATE_GALK_LAB_JOB_ASSIGNED = "UPDATE_GALK_LAB_JOB_ASSIGNED";
export const UPDATE_GALK_LAB_JOB_UNASSIGNED = "UPDATE_GALK_LAB_JOB_UNASSIGNED";
export const UPDATE_GALK_LAB_TAG_ASSIGNED = "UPDATE_GALK_LAB_TAG_ASSIGNED";
export const UPDATE_GALK_LAB_TAG_UNASSIGNED = "UPDATE_GALK_LAB_TAG_UNASSIGNED";
export const UPDATE_GALK_LAB_JOB_ASSIGN_PORCESSING =
	"UPDATE_GALK_LAB_JOB_ASSIGN_PORCESSING";

// Organisational data
export const SET_SKILLS = "SET_SKILLS";
export const SET_BRANCHES = "SET_BRANCHES";
export const SET_COLLEGES = "SET_COLLEGES";
